import { EWalletId, ProviderEvents } from '@ankr.com/provider';

import { InitSliceListenersParams } from 'store/queries/types';
import { getProviderManager } from 'modules/api/getProviderManager';
import { isEventProvider } from 'store/utils/isEventProvider';
import { signOut } from 'modules/auth/actions/signOut';
import { MultiService } from 'modules/api/MultiService';
import { resetEndpoint } from 'store/utils/resetEndpoint';
import { AppDispatch } from 'store/store';

import { createWeb3Service } from '../actions/createWeb3Service';
import { setNetworkId, setWalletAddress, setWalletMeta } from './walletSlice';

export const initWalletListeners = ({
  listenerMiddleware,
}: InitSliceListenersParams) => {
  listenerMiddleware.startListening({
    matcher: createWeb3Service.matchFulfilled,
    effect: async (_action, { dispatch }) => {
      const providerManager = getProviderManager();
      const ethWeb3KeyProvider = await providerManager.getETHWriteProvider(
        EWalletId.injected,
      );
      const web3 = ethWeb3KeyProvider.getWeb3();
      const provider = web3?.currentProvider;

      dispatch(setWalletMeta(ethWeb3KeyProvider.getWalletMeta()));
      dispatch(setWalletAddress(ethWeb3KeyProvider.currentAccount));
      dispatch(setNetworkId(ethWeb3KeyProvider.currentChain));

      if (isEventProvider(provider)) {
        const disconnectHandler = () => {
          dispatch(signOut.initiate());
        };

        const chainChangedHandler = (data: string) => {
          const chainId = data.startsWith('0x')
            ? data
            : web3.utils.numberToHex(data);

          const networkId = Number.parseInt(chainId, 16);

          dispatch(setNetworkId(networkId));
        };

        const accountsChangedHandler = (connectedAddresses: string[]) => {
          const address = connectedAddresses?.[0];

          dispatch(setWalletAddress(address));

          ethWeb3KeyProvider.currentAccount = address;

          if (!address) {
            resetEndpoint(createWeb3Service.name, dispatch as AppDispatch);

            MultiService.removeWeb3Services();
          }
        };

        provider.on(ProviderEvents.Disconnect, disconnectHandler);
        provider.on(ProviderEvents.ChainChanged, chainChangedHandler);
        provider.on(ProviderEvents.AccountsChanged, accountsChangedHandler);
      }
    },
  });
};
